export default __webpack_public_path__ + "static/media/4.18b8bb52.mp4";